'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

exports.default = LayoutMobileContent;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _offCanvas = require('../offCanvas');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * WH Layout Mobile Content Component.
 * @param {Object} props The new component properties.
 * @returns {React$Element<any>} HTML markup for the component
 */
function LayoutMobileContent(props) {
    var className = props.className,
        children = props.children,
        _props$id = props.id,
        id = _props$id === undefined ? '' : _props$id;


    return (0, _jsx3.default)(_offCanvas.OffCanvasContent, {
        id: id,
        className: className
    }, void 0, children);
}
//# sourceMappingURL=LayoutMobileContent.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/layoutMobile/LayoutMobileContent.js
// module id = 573
// module chunks = 0